/** 进入专区 **/
export const INDUSTRY_ZONE_URL =
  process.env.VUE_APP_OLD_SEARCH_URL + "/specialArea.html#";
export const INDUSTRY_ZONE_DETAIL_URL =
  process.env.VUE_APP_OLD_DETAIL_URL + "/tenderDetail.html";

export const INDUSTRY_ZONE_ID_MAP = {
  PROPERTY_MANAGEMENT: 1, // 物业
};
